/*
 * SectionSubNavigation
 * @module components
 * @flow weak
 */

import React from 'react';
import { compose, lifecycle, pure, withHandlers, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import * as R from 'ramda';

import { withDevice } from '~/features/App/Device';
import { findRouteIndexByPathname, scrollTabs } from '~/helpers';

import { SectionSubNavigation as SSN } from './SectionSubNavigation';

const prepareTabs = routes =>
  R.pipe(
    R.values,
    R.map(({ link, route }) => ({
      link,
      route,
      ref: React.createRef(),
    })),
  )(routes);

const enhance = compose(
  withDevice,
  withRouter,
  withProps(({ routes }) => ({
    navRef: React.createRef(),
    scrollRef: React.createRef(),
    tabs: prepareTabs(routes),
  })),
  withHandlers({
    scrollNavigation: ({
      device,
      location: { pathname },
      navRef,
      scrollRef,
      tabs,
    }) => () => {
      if (device === 'desktop') {
        return;
      }

      scrollTabs({
        index: findRouteIndexByPathname(pathname, tabs),
        navRef,
        scrollRef,
        tabs,
      });
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.scrollNavigation();
    },
    componentDidUpdate() {
      this.props.scrollNavigation();
    },
  }),
  pure,
);

export const SectionSubNavigation = enhance(SSN);
